import { FC } from 'react';
import { css } from '@bts-web/utils-style-engine';
import { FilledDismiss, FilledSearch } from '../../../common/svgIcons';
import { useTransfersAssetsListContext } from '../TransfersAssetListContext/TransfersAssetListContext';
import { MAXIMUM_SEARCH_TERM_LENGTH } from '../../../config';
import { SearchBar } from '../../../common/components';

export interface CryptoTransfersSearchBarTranslations {
  searchAssets: string;
}

interface CryptoTransfersSearchBarProps {
  placeholder: string;
  disabled?: boolean;
}

export const CryptoTransfersSearchBar: FC<CryptoTransfersSearchBarProps> = ({
  placeholder,
  disabled,
}) => {
  const { onInputChange, assetFilterSearchValue } =
    useTransfersAssetsListContext();

  return (
    <div className={css({ px: 'medium', py: 'extra_small' })}>
      <SearchBar
        value={assetFilterSearchValue}
        searchIcon={<FilledSearch size={24} />}
        dismissIcon={<FilledDismiss />}
        placeholder={placeholder}
        onChange={onInputChange}
        onClear={() => {
          onInputChange('');
        }}
        maxLength={MAXIMUM_SEARCH_TERM_LENGTH}
        disabled={disabled}
      />
    </div>
  );
};
